import React from "react";
import Flag from "../../components/Flag";
import { displayStats } from "../playerStats";

function Chevron({ up }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-2.5 h-2.5"
    >
      {up ? (
        <polyline points="6 14 12 8 18 14" />
      ) : (
        <polyline points="6 10 12 16 18 10" />
      )}
    </svg>
  );
}

export default function PlayerRow({
  player,
  selected,
  disabled,
  chemAvailable,
  onClick,
}) {
  const mod = player.formMod;

  return (
    <button
      type="button"
      onClick={() => !disabled && onClick(player)}
      disabled={disabled}
      className={`w-full text-left rounded-xl border transition px-3 md:px-4 py-3 flex items-center gap-3
        ${
          disabled
            ? "bg-zinc-900/20 border-zinc-900 opacity-40 cursor-not-allowed"
            : selected
              ? "bg-zinc-900 border-emerald-500/60"
              : "bg-zinc-900/40 border-zinc-800 hover:border-zinc-700 hover:bg-zinc-900/70"
        }`}
    >
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-zinc-100 truncate">
          {player.name}
        </div>
        <div className="text-xs text-zinc-500 mt-1 flex items-center gap-1.5">
          <Flag nation={player.nation} className="text-base shrink-0" />
          <span className="truncate min-w-0">
            {(player.positions || [player.pos]).join(" · ")}
          </span>

          {mod?.type === "form" && (
            <span
              title={`Hot form: +${mod.delta} ${mod.stat}`}
              className="shrink-0 inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide
                         text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded px-1.5 py-0.5"
            >
              <Chevron up /> Form
            </span>
          )}
          {mod?.type === "injury" && (
            <span
              title={`Injury: ${mod.delta} ${mod.stat}`}
              className="shrink-0 inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide
                         text-red-300 bg-red-500/10 border border-red-500/30 rounded px-1.5 py-0.5"
            >
              <Chevron /> Injury
            </span>
          )}
          {chemAvailable && (
            <span
              title={`Builds ${player.nation} chemistry`}
              className="shrink-0 inline-flex items-center gap-0.5 text-[9px] font-bold uppercase tracking-wide
                         text-sky-300 bg-sky-500/10 border border-sky-500/30 rounded px-1.5 py-0.5"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                className="w-2.5 h-2.5"
              >
                <path d="M9 12a3 3 0 0 0 3 3l3-3a3 3 0 0 0-4.5-4" />
                <path d="M15 12a3 3 0 0 0-3-3l-3 3a3 3 0 0 0 4.5 4" />
              </svg>
              Chem
            </span>
          )}
        </div>
      </div>

      <div className="grid grid-cols-6 gap-1 md:gap-2 text-center shrink-0">
        {displayStats(player).map(({ key, value }) => {
          const modType = mod?.stat === key ? mod.type : null;
          return (
            <div key={key} className="w-7 md:w-9">
              <div
                className={`text-xs md:text-sm font-semibold tabular-nums ${
                  modType === "form"
                    ? "text-emerald-400"
                    : modType === "injury"
                      ? "text-red-400"
                      : "text-zinc-200"
                }`}
              >
                {value ?? "–"}
              </div>
              <div className="text-[9px] font-semibold tracking-wider text-zinc-500 mt-0.5">
                {key}
              </div>
            </div>
          );
        })}
      </div>
    </button>
  );
}
